import { environment } from '../../../environments/environment';

export const UrlConfig: any = {
  baseUrl: environment.nhwsApiEndPoint,
  planLiteApiBaseUrl: environment.planLiteApiEndpoint,
  quoteLiteApiBaseUrl: environment.quoteLiteApiEndpoint,
  censusLiteApiBaseUrl: environment.censusLiteApiEndpoint,
  userApiBaseUrl: environment.userApiEndPoint,
  nqsPlanApiUrl: environment.nqsPlanApiEndPoint,
  wbQuoteUrl: environment.wbQuoteUrl,
  quoteLiteUrl: environment.quoteLiteUrl,
  nqsQuoteApiBaseUrl: environment.nqsQuoteApiEndPoint,
  nhwsUrl: environment.redirectUri,
  medIdApiUri: environment.medIdApiUri,
  carrierLogosUrl: environment.carrierLogosUrl,
};
